export const ButtonTextStyle = {
  width: '55vw',
  minWidth: 'fit-content',
  fontSize: '1rem',
  padding: '3px',
  paddingBottom: '7px',
  boxShadow: 'none',

  color: '#000',
  backgroundColor: '#fff',
  borderRadius: '2px',
};

export const IconButtonStyle = {
  background: 'white',
  borderRadius: '4px',
  p: '3px',
  color: '#989898',
  '&:hover': {
    opacity: '0.8',
    background: 'white',
  },
};
